import { type ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';

import { OffersCarousel } from '@fhs/loyalty/src/components/offers-carousel';
// TODO: Uncomment when personalized homepage config is available
// import { PageBuilderRenderer } from '@fhs/page-builder';
import { ScrollView, Text, tokens } from '@fhs/ui';

// TODO: Uncomment when personalized homepage config is available
// import { useActionHandler } from '../use-action-handler';
// import { useLoyaltyHomepageConfigQuery } from '../use-loyalty-homepage-config-query';

import { WelcomeMessage } from './welcome-message';

export type PersonalizedHomepageProps = {
  legacyHomeCard: ReactNode;
  legacyHomepageAlert: ReactNode;
};

export function PersonalizedHomepage(props: PersonalizedHomepageProps) {
  // TODO: Replace with personalized homepage config query when available
  // const { data: loyaltyHomepageConfigDocument } = useLoyaltyHomepageConfigQuery();
  // const layout = loyaltyHomepageConfigDocument?.unauthenticatedUsers?.layout;
  // const widgets = loyaltyHomepageConfigDocument?.unauthenticatedUsers?.widgets ?? [];
  // const handleAction = useActionHandler();

  return (
    <ScrollView style={styles.scroller}>
      {props.legacyHomepageAlert}
      <WelcomeMessage />

      {/* TODO: Replace when personalized homepage config query is available */}
      {/* {layout && (
        <PageBuilderRenderer
          layout={layout}
          widgets={widgets}
          onAction={handleAction}
          legacyHomeCard={props.legacyHomeCard}
        />
      )} */}

      {/* MY OFFERS */}
      <View style={styles.offersSection}>
        <Text style={styles.sectionTitle}>My Offers</Text>
        <OffersCarousel />
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scroller: {
    flexGrow: 1,
  },
  offersSection: {
    marginTop: 16,
    width: '100%',
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: tokens.colors.$black,
    paddingHorizontal: 16,
    marginBottom: 8,
  },
});
